import React, { useContext } from 'react';
import './StatusStatistics.scss';
import { Row } from 'antd';
import { useStatusCounts } from 'hooks/jobs';
import { AppContext } from 'contexts/AppContext';
import { FormattedMessage } from 'react-intl';
import { JobStatus } from 'components/StatusTag/StatusTag';
import StatusFilterCard from './StatusFilterCardProps/StatusFilterCard';
interface StatusStatisticsProps {
  jobStatusFilters: JobStatus[];
  setJobStatusFilters: React.Dispatch<React.SetStateAction<JobStatus[]>>;
}

function StatusStatistics({
  jobStatusFilters,
  setJobStatusFilters,
}: StatusStatisticsProps) {
  const { clusterName } = useContext(AppContext);
  const { setCurrentAppliedFilters } = useContext(AppContext);

  const isEnabled = !!clusterName ? true : false;

  const { data: statusUnfilteredCounts, isLoading: isStatusCountsLoading } =
    useStatusCounts({
      clusterName: clusterName as string,
      isEnabled,
    });

  return (
    <Row className="status-card-list__wrapper">
      <StatusFilterCard
        jobStatusFilters={jobStatusFilters}
        setJobStatusFilters={setJobStatusFilters}
        statusUnfilteredCounts={statusUnfilteredCounts?.data?.In_Queue || 0}
        title={<FormattedMessage id="filters.status.inQueue" />}
        isStatusCountsLoading={isStatusCountsLoading}
        setCurrentAppliedFilters={setCurrentAppliedFilters}
        JobStatusType={JobStatus.In_Queue}
        JobStatusClass="--in-queue"
      />
      <StatusFilterCard
        jobStatusFilters={jobStatusFilters}
        setJobStatusFilters={setJobStatusFilters}
        statusUnfilteredCounts={statusUnfilteredCounts?.data?.Running || 0}
        title={<FormattedMessage id="filters.status.running" />}
        isStatusCountsLoading={isStatusCountsLoading}
        setCurrentAppliedFilters={setCurrentAppliedFilters}
        JobStatusType={JobStatus.Running}
        JobStatusClass="--running"
      />
      <StatusFilterCard
        jobStatusFilters={jobStatusFilters}
        setJobStatusFilters={setJobStatusFilters}
        statusUnfilteredCounts={statusUnfilteredCounts?.data?.Succeeded || 0}
        title={<FormattedMessage id="filters.status.succeeded" />}
        isStatusCountsLoading={isStatusCountsLoading}
        setCurrentAppliedFilters={setCurrentAppliedFilters}
        JobStatusType={JobStatus.Succeeded}
        JobStatusClass="--succeeded"
      />
      <StatusFilterCard
        jobStatusFilters={jobStatusFilters}
        setJobStatusFilters={setJobStatusFilters}
        statusUnfilteredCounts={statusUnfilteredCounts?.data?.Failed || 0}
        title={<FormattedMessage id="filters.status.failed" />}
        isStatusCountsLoading={isStatusCountsLoading}
        setCurrentAppliedFilters={setCurrentAppliedFilters}
        JobStatusType={JobStatus.Failed}
        JobStatusClass="--failed"
      />
      <StatusFilterCard
        jobStatusFilters={jobStatusFilters}
        setJobStatusFilters={setJobStatusFilters}
        statusUnfilteredCounts={statusUnfilteredCounts?.data?.Cancelled || 0}
        title={<FormattedMessage id="filters.status.cancelled" />}
        isStatusCountsLoading={isStatusCountsLoading}
        setCurrentAppliedFilters={setCurrentAppliedFilters}
        JobStatusType={JobStatus.Cancelled}
        JobStatusClass="--cancelled"
      />
      <StatusFilterCard
        jobStatusFilters={jobStatusFilters}
        setJobStatusFilters={setJobStatusFilters}
        statusUnfilteredCounts={statusUnfilteredCounts?.data?.Timed_Out || 0}
        title={<FormattedMessage id="filters.status.timed-out" />}
        isStatusCountsLoading={isStatusCountsLoading}
        setCurrentAppliedFilters={setCurrentAppliedFilters}
        JobStatusType={JobStatus.Timed_Out}
        JobStatusClass="--timed-out"
      />
    </Row>
  );
}

export default StatusStatistics;
